import PortalIdParser from 'PortalIdParser';
const RECENTLY_DELETED_ACTION_SET_IDS_KEY = 'recentlyDeletedActionSetIds';
const getIdsFromSessionStorage = () => {
  try {
    const ids = sessionStorage.getItem(`${RECENTLY_DELETED_ACTION_SET_IDS_KEY}-${PortalIdParser.get()}`);
    return ids ? JSON.parse(ids) : [];
  } catch (err) {
    return [];
  }
};
const setIdInSessionStorage = id => {
  try {
    const ids = getIdsFromSessionStorage();
    ids.push(id);
    sessionStorage.setItem(`${RECENTLY_DELETED_ACTION_SET_IDS_KEY}-${PortalIdParser.get()}`, JSON.stringify(ids));
  } catch (err) {
    return;
  }
};
const useRecentlyDeletedActionSetIds = () => {
  const recentlyDeletedActionSetIds = getIdsFromSessionStorage();
  const addDeletedActionSetId = id => {
    setIdInSessionStorage(id);
  };
  return {
    recentlyDeletedActionSetIds,
    addDeletedActionSetId
  };
};
export default useRecentlyDeletedActionSetIds;